const textStyles = {
  a: {
    color: "gradient",
    fontSize: "12px",
    lineHeight: "14.5px",
    fontWeight: 400,
  },
  h1: {
    fontSize: "22px",
    lineHeight: "26.63px",
    fontWeight: 500,
  },
  h2: {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: 600,
    fontFamily: "inter",
    color: "darkBlue",
  },
  "input-label": {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
  },
  "credit-card": {
    color: "white",
    fontFamily: "ibm",
    fontSize: "11.65px",
    lineHeight: "17.48px",
    fontWeight: 400,
  },
  enquiry: {
    color: "black",
    fontFamily: "inter",
    fontSize: "12px",
    lineHeight: "22px",
    fontWeight: 400,
  },
  "alert-title": {
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 500,
    color: "darkBlue",
  },
  "alert-description": {
    fontSize: "12px",
    lineHeight: "15px",
    fontWeight: 400,
    color: "darkBlue",
  },
};

export default textStyles;
